export default __webpack_public_path__ + "d18134b8841dbc8a8a8fec11ccf86c01.svg";